import React, { useEffect, useState, useRef } from "react";
import ReactQuill from 'react-quill'; // Importa o editor de texto
import 'react-quill/dist/quill.snow.css'; // Estilos do editor


import styled from 'styled-components'
import {
  Alert, Autocomplete, Avatar, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel,
  FormGroup, FormLabel, Hidden, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination,
  TableRow, TextField, Tooltip
} from "@mui/material";
import FileViewer from '../components/fileViewer';

import TaskItemDoChamado from "../components/task-item-do-chamado";
import PerfilUtils from "../utils/perfil.utils";
import MessageIcon from '@mui/icons-material/Message';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';




import PersonIcon from '@mui/icons-material/Person';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import UploadButton from "../components/UploadButton";
import { color } from "@mui/system";
import TaskFilter from "../components/task-filter";
import Upload from "../components/uploadComponent";
const getCookie = require('../utils/getCookie')

const PageContainer = styled.div`
  margin: 16px;
  padding: 32px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0px 0px 20px -18px #424242;
`

const AtividadeForm = (props) => {
  const { logged } = props

  const [checked, setChecked] = React.useState(false);
  // alert(JSON.stringify(logged.nome))
  const [arquivado, setArquivado] = useState(true)
  const [open, setOpen] = useState(false);
  const [openImg, setOpenImg] = useState(false);
  const [openMsg, setOpenMsg] = useState(false);
  const [openMsg1, setOpenMsg1] = useState(false);
  const [openMsg3, setOpenMsg3] = useState(false);
  const [openMsg2, setOpenMsg2] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const fileInputRef = useRef(null);
  const [uploadResult, setUploadResult] = useState(null);
  const [pesquisa, setPesquisa] = useState("")
  const { id } = props.match.params;
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false)
  const [openMessageDialog, setOpenMessageDialog] = useState(false)
  const [message, setMessage] = useState('')
  const [classificacao, setClassificacao] = useState('')
  const [newClassificacao, setNewClassificacao] = useState('')
  const [newStatus, setNewStatus] = useState('')
  const [newStatusControler, setNewStatusControler] = useState('')
  const [statusId, setStatusId] = useState('')
  const [setorDemandante, setSetorDemandante] = useState('')
  const [protocolo, setProtocolo] = useState('')
  const [status, setStatus] = useState('')
  const [valueArea, setValueArea] = useState('')
  const [valueUnidade, setValueUnidade] = useState('')
  const [usuarioSolicitante, setUsuarioSolicitante] = useState('')
  const [emailUsuarioSolicitante, setEmailUsuarioSolicitante] = useState('')
  const [telefoneSolicitante, setTelefoneSolicitante] = useState('')
  const [setorSolicitante, setSetorSolicitante] = useState('')
  const [categoriaChamado, setCategoriaChamado] = useState('')
  const [btnMsg, setBtnMsg] = useState(false);

  const [tempoEstimado, setTempoEstimado] = useState('')
  const [createdAt, setCreatedAt] = useState('')
  const [title, setTitle] = useState('')
  const [botaoDesabilitado, setBotaoDesabilitado] = useState(false);
  const [gti, setGti] = useState('')
  const [titulo, setTitulo] = useState('')
  const [conteudo, setConteudo] = useState('')
  const [conteudoFuncionario2, setConteudoFuncionario2] = useState('')
  const [fkUnidade, setFkUnidade] = useState('')
  const [fkUnidadeDrop, setFkUnidadeDrop] = useState('')
  const [dep, setDep] = useState('')
  const [fkArea, setFkArea] = useState('')
  const [fkCategoria, setFkCategoria] = useState('')
  const [unidade, setUnidade] = useState([])
  const [arquivoDoChamado, setArquivoDoChamado] = useState([])
  const [unidadeTrue, setUnidadeTrue] = useState([])
  const [area, setArea] = useState([])
  const [subArea, setSubArea] = useState([])
  const [atividade, setAtividade] = useState(null)
  const [mensagens, setMensagens] = useState([])
  const [classificarChamado, setClassificarChamado] = useState([])
  const [alterarStatus, setAltararStatus] = useState([])
  const [fkUnidadeExecutor, getFkUnidadeExecutor] = useState('')
  const [meuSetor, setMeuSetor] = useState([]);
  const [meuSetorCount, setMeuSetorCount] = useState([]);
  const [logChamado, setLogChamado] = useState([]);
  const [outrosExecutores, setOutrosExecutores] = useState([]);




  const [hash, setHash] = useState('')


  const [usuarioExecutor, setusuarioExecutor] = useState([])
  const [fkUsuarioExecutor, setFKUsuarioExecutor] = useState('')
  const [fkUsuarioExecutor2, setFKUsuarioExecutor2] = useState('')
  const [fkAreaDemandada, setFkAreaDemandada] = useState('')
  const [nomeExecutor, getNomeExecutor] = useState('')
  const [emailExecutor, getEmailExecutor] = useState('')
  const [telefoneExecutor, getTelefoneExecutor] = useState('')
  const [fkDemandante, setFkDemandante] = useState('')
  const [fkUsuarioSolicitante, setFkUsuarioSolicitante] = useState('')
  const [fkExecutor, getFkExecutor] = useState('')
  const [categoria, setCategoria] = useState('')
  const [emailAC, setEmailAc] = useState('')
  const [emailsFuncionarios, setEmailsFuncionarios] = useState('')
  const [errorMessage, setErrorMessage] = useState('');
  const [arquivo, setArquivo] = useState(null)
  const [listaDeArquivosEnviados, setListaDeArquivosEnviados] = useState([])
  const [caminho, setCaminho] = useState()
  const [openDialogFile, setOpenDialogFile] = useState(false)
  const [checkDemandante, setCheckDemandante] = useState(false)
  const [termo, setTermo] = useState(false)
  const [termo1, setTermo1] = useState(false)
  const [termo2, setTermo2] = useState(false)
  const [ordem, setOrdem] = useState(null); // Estado para guardar o email do funcionário selecionado

  const [openFile, setOpenFile] = useState('')
  const [sub, setSub] = useState('')
  const [cpfTermo, setCpfTermo] = useState('')
  const [mensagemAlert, setMensagemAlert] = useState('')
  const [openMensagens, setOpenMensagens] = useState(false)
  const [openValidation, setOpenValidation] = useState(false)
  const [idChamado, setIdChamado] = useState('')
  const mensagemft = require('../assets/msg.jpg')
  const anexo = require('../assets/anexo.jpg')
  const send = require('../assets/target.png')



  const validationFinal = () => {
    if (logged && props.logged.id === fkUsuarioSolicitante && status === 'Concluido' && checkDemandante === false) {
      setOpenValidation(true)

    }
  }
  const [dataLoaded, setDataLoaded] = useState(false); // Estado para verificar se os dados foram carregados


  useEffect(() => {
    // Simulando o carregamento dos dados
    const fetchData = async () => {
      try {
        // Substitua pelo carregamento real de dados
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setDataLoaded(true); // Defina como carregado após os dados estarem disponíveis
      } catch (error) {
        console.error("Erro ao carregar os dados:", error);
      }
    };

    fetchData();
  }, []); // O array vazio significa que o efeito será executado apenas uma vez ao montar o componente

  useEffect(() => {
    if (dataLoaded) {
      validationFinal(); // Chame a validação após os dados estarem carregados
    }
  }, [dataLoaded]); // Executa o efeito quando `dataLoaded` mudar







  const salvarArquivo = () => {
    // alert(newStatus)
    const token = getCookie('_token_task_manager')
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({

        nomeArquivo: uploadResult.data.nome,
        hash: uploadResult.data.hash

      })

    }

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/arquivo/api`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          setOpenLoadingDialog(false)
          if (status === 401) {
            alert(2)
            // setOpenMessageDialog(true)
          } else if (status === 200) {
            alert(data.message)

          }
        }).catch(err => setOpenLoadingDialog(true))
      })
  }




  const handleUpload = () => {
    const file = fileInputRef.current.files[0];

    if (!file) {
      setErrorMessage('Por favor, selecione um arquivo.');
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("keyapi", "99bd4c69-322d-424d-8b9c-4622fdd997ab");

    const formData = new FormData();
    formData.append("arquivo", file, file.name);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow"
    };

    fetch("https://www7.pe.senac.br/storage/api/arquivo", requestOptions)
      .then(response => {
        console.log('Status da resposta:', response.status);
        console.log('Cabeçalhos da resposta:', Array.from(response.headers.entries()));

        // Verificar se a resposta foi bem-sucedida
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return response.text(); // Lê a resposta como texto
      })
      .then(result => {
        console.log('Resposta recebida:', result); // Mostra a resposta bruta

        try {
          const parsedResult = JSON.parse(result);
          console.log('Resposta parseada:', parsedResult); // Mostra a resposta parseada
          setUploadResult(parsedResult);
          setErrorMessage('');

        } catch (e) {
          console.error('Erro ao parsear a resposta:', e);
          setErrorMessage('Ocorreu um erro ao salvar o arquivo.');
        }
      })
      .catch(error => {
        console.error('Erro ao fazer o fetch:', error);
        setUploadResult(null);
        setErrorMessage('Ocorreu um erro ao salvar o arquivo.');
      })
  };

  useEffect(() => {


    if (uploadResult) {
      setHash(uploadResult.data.hash)
      salvarArquivo()

    }

    if (idChamado.length > 0) {
      log()
    }

    if (pesquisa) {
      pesquisar()
    }





    // if(fkUnidade){
    //   alert(fkUnidade)
    // }
  }, [uploadResult, idChamado, pesquisa])

  function pesquisar() {
    const token = getCookie('_token_task_manager')
    const params = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    }
    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/usuarioDemandado/search?pesquisa=${pesquisa}`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          // setOpenLoadingDialog(false)

          if (status === 401) {
            // alert(status)
          } else if (status === 200) {
            // alert(pesquisa)
            // alert(JSON.stringify(data.data))
            // setRespostas(data.data)
            setEmailsFuncionarios(data.data)
          }
        }).catch(err => console.log(err))
      })
  }






  const toggleChecked = () => {
    setChecked((prev) => !prev);
  };






  useEffect(() => {
    function carregarRegistro() {
      setOpenLoadingDialog(true)
      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade/${id}`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)
            if (status === 401) {
              setMessage(data.message)
              setOpenMessageDialog(true)
            } else if (status === 200) {
              setClassificacao(data.data.Classificacao.nome)
              setProtocolo(data.data.protocoloID)
              setStatus(data.data.Status.nome)
              setStatusId(data.data.Status.id)
              setValueArea(data.data.Area.nome)
              setSetorSolicitante(data.data.Usuario.Area.Unidade.nome)
              setValueUnidade(data.data.Area.Unidade.nome)
              getFkUnidadeExecutor(data.data.Area.fkUnidade)
              setUsuarioSolicitante(data.data.Usuario.nome)
              setEmailUsuarioSolicitante(data.data.Usuario.email)
              setTelefoneSolicitante(data.data.Usuario.telefone)
              setFkDemandante(data.data.fkDemandante)
              setEmailAc(data.data.acompanhamento)
              setCategoriaChamado(data.data.categoria)
              setTitle(data.data.titulo)
              setCheckDemandante(data.data.arquivado)
              setFkAreaDemandada(data.data.fkArea)
              setIdChamado(data.data.id)
              setFkUsuarioSolicitante(data.data.fkUsuarioSolicitante)
              getNomeExecutor(data.data.UsuarioExecutor.nome)
              getEmailExecutor(data.data.UsuarioExecutor.email)
              getTelefoneExecutor(data.data.UsuarioExecutor.telefone)
              getFkExecutor(data.data.UsuarioExecutor.id)




              carregarMensagem()
              // alert(emailExecutor)

            }
          }).catch(err => setOpenLoadingDialog(false))
        })
    }




    function carregarMensagem() {
      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`,

        },
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/mensagem/?fkAtividade=${id}`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)
            if (status === 401) {
              setMessage(data.message)
              setOpenMessageDialog(true)
            } else if (status === 200) {

              setOpenLoadingDialog(false)
              setMensagens(data.data)
            }
          }).catch(err => setOpenLoadingDialog(false))
        })
    }

    function carregarUsuarioSecundario() {

      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`,

        },
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/outrosExecutores/${id}`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)
            if (status === 401) {
              setMessage(data.message)

              setOpenMessageDialog(true)
            } else if (status === 200) {



              setOpenLoadingDialog(false)
              setOutrosExecutores(data.data)
            }
          }).catch(err => setOpenLoadingDialog(false))
        })
    }

    function carregarUnidade() {
      // setOpenLoadingDialog(true)
      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/unidade`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)
            if (status === 401) {
            } else if (status === 200) {
              // alert(data.data.nome)
              // if(data.data.nome === 'DEP'){
              setUnidade(data.data)
              // }

              filtroUnidade()
              if (id) {
                carregarRegistro()

              } else {
                setOpenLoadingDialog(false)
              }
            }
          }).catch(err => setOpenLoadingDialog(true))
        })
    }




    function carregarAtividadesDoSetor() {
      setOpenLoadingDialog(true);
      const token = getCookie("_token_task_manager");
      const params = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      fetch(
        `${process.env.REACT_APP_DOMAIN_API}/api/atividade/recebidasSetor/`,
        params
      ).then((response) => {
        const { status } = response;
        response.json().then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
          } else if (status === 200) {
            setOpenLoadingDialog(false);
            // alert(JSON.stringify(data.data))
            setMeuSetor(data.data);
          }
        });
      });
    }


    function carregarAtividadesDoSetorCount() {
      setOpenLoadingDialog(true);
      const token = getCookie("_token_task_manager");
      const params = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      fetch(
        `${process.env.REACT_APP_DOMAIN_API}/api/atividade/recebidasSetorCount/`,
        params
      ).then((response) => {
        const { status } = response;
        response.json().then((data) => {
          setOpenLoadingDialog(false);
          if (status === 401) {
          } else if (status === 200) {
            setOpenLoadingDialog(false);

            // alert(JSON.stringify(data.data))

            setMeuSetorCount(data.data);
          }
        });
      });
    }


    function carregarArquivo() {
      // setOpenLoadingDialog(true)
      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/arquivo/?fkAtividade=${id}`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)
            if (status === 401) {
            } else if (status === 200) {

              setArquivoDoChamado(data.data)

            }
          }).catch(err => setOpenLoadingDialog(true))
        })
    }


    function filtroUnidade() {
      // alert(JSON.stringify(unidade))
      setUnidadeTrue(unidade.filter(item => item.receber === true))
    }


    function carregarClassificacao() {
      // setOpenLoadingDialog(true)
      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/classificacao/`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)

            if (status === 401) {

            } else if (status === 200) {
              setClassificarChamado(data.data)
              // alert("3")
              // alert(JSON.stringify(data))

            }
          }).catch(err => setOpenLoadingDialog(true))
        })
    }


    function carregarStatus() {
      // setOpenLoadingDialog(true)
      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/status/`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)

            if (status === 401) {

            } else if (status === 200) {
              setAltararStatus(data.data)
              // alert("3")
              // alert(JSON.stringify(data))

            }
          }).catch(err => setOpenLoadingDialog(true))
        })
    }

    function carregarFuncionarios() {
      // setOpenLoadingDialog(true)
      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/usuarioAtividade/`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)

            if (status === 401) {
              // alert(status)
            } else if (status === 200) {
              setusuarioExecutor(data.data)
              // filtrarUsuariosDemandados()

            }
          }).catch(err => setOpenLoadingDialog(true))
        })
    }





    if (id) {
      carregarRegistro()
      carregarClassificacao()
      carregarFuncionarios()
      carregarStatus()
      carregarArquivo()
      carregarUsuarioSecundario()


      carregarMensagem()
      carregarAtividadesDoSetor()
      carregarAtividadesDoSetorCount()


    } else {
      carregarUnidade()

    }

    // if(meuSetor){
    //   alert(JSON.stringify(meuSetor))
    // }


  }, [fkUnidade, area])
  const handleEncaminhar = (email) => {
    setOrdem(email); // Armazena o email no estado 'ordem'
  };




  useEffect(() => {
    if (ordem && id) {
      onSaveTarget(); // Executa a função apenas após 'ordem' ser atualizado
    }


  }, [ordem,]);

  const handleEncaminharTarget = (email) => {
    setOrdem(email); // Atualiza o estado com o email selecionado
  };




  // useEffect(() => {



  // }, [listaDeArquivosEnviados])



  useEffect(() => {
    function carregarArea() {

      // setOpenLoadingDialog(true)
      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/area/?fkUnidade=${fkUnidade}`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)
            if (status === 401) {
            } else if (status === 200) {
              setArea(data.data)
              setOpenLoadingDialog(false)


            }
          }).catch(err => setOpenLoadingDialog(true))
        })
    }

    if (fkUnidade) {
      carregarArea()


    }
  }, [fkUnidade])

  useEffect(() => {
    function carregarSubArea() {
      // setOpenLoadingDialog(true)
      const token = getCookie('_token_task_manager')
      const params = {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
      fetch(`${process.env.REACT_APP_DOMAIN_API}/api/subarea/?fkArea=${fkArea}`, params)
        .then(response => {
          const { status } = response
          response.json().then(data => {
            setOpenLoadingDialog(false)
            if (status === 401) {
            } else if (status === 200) {
              setSubArea(data.data)
              setOpenLoadingDialog(false)

            }
          }).catch(err => setOpenLoadingDialog(true))
        })
    }

    if (fkArea) {
      carregarSubArea()


    }
  }, [fkArea])

  // const onSaveStatus = () => {
  //   setOpenMsg(true)
  //   onSaveStatusA()

  // }



  const onSaveTarget = () => {




    const token = getCookie('_token_task_manager')
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        fkStatus: newStatus,
        tempoEstimado: 0,
        // email: emailUsuarioSolicitante,
        // titulo: title,
        ordem


      })

    }

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade/${id}/updateTarget`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          setOpenLoadingDialog(false)
          if (status === 401) {
            setMessage(data.message)
            setOpenMessageDialog(true)
          } else if (status === 200) {
            setMessage(data.message)
            window.location.reload()

            //  window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${idChamado}/edit`


            // setArea(data.data)
          }
        }).catch(err => setOpenLoadingDialog(true))
      })
  }



  const onSaveStatus = () => {
    // alert(newStatus)


    const token = getCookie('_token_task_manager')
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        fkStatus: newStatus,
        tempoEstimado,
        // email: emailUsuarioSolicitante,
        // titulo: title,


      })

    }

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade/${id}/edit`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          setOpenLoadingDialog(false)
          if (status === 401) {
            setMessage(data.message)
            setOpenMessageDialog(true)
          } else if (status === 200) {
            setMessage(data.message)
            setOpenMessageDialog(true)
            setOpenMsg(true)
            //  window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${idChamado}/edit`


            // setArea(data.data)
          }
        }).catch(err => setOpenLoadingDialog(true))
      })
  }


  const onSave = () => {
    setOpenLoadingDialog(true)
    setBotaoDesabilitado(true);
    // setSetorSolicitante(props.logged.Area.Unidade.nome)

    const token = getCookie('_token_task_manager')
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },

      body: JSON.stringify({
        hash,
        setorSolicitante: props.logged.Area.Unidade.nome,
        listaDeArquivosEnviados,
        caminho,
        fkUnidade,
        fkArea,
        categoria,
        titulo,
        ordem,
        conteudo,
        arquivado: false
      })

    }


    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade/`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          setOpenLoadingDialog(false)
          if (status === 401) {
            setMessage(data.message)
            setOpenMessageDialog(true)
          } else if (status === 200) {
            setAtividade(data.data)
            setOpenLoadingDialog(false)
            // setMessage(data.message)
            setOpenMessageDialog(true)
            window.location.href = `${process.env.REACT_APP_DOMAIN}/chamadosAbertos/`


            // setArea(data.data)
          }
        }).catch(err => setOpenLoadingDialog(true))
      })
  }

  // const onSaveMeu = () => {
  //   const token = getCookie('_token_task_manager')
  //   const params = {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${token}`
  //     },
  //     body: JSON.stringify({
  //       fkUnidade: logged.Area.fkUnidade,
  //       fkArea : logged.fkArea,
  //       titulo,
  //       conteudo,
  //       arquivado: false,
  //       pessoal: true,
  //       fkUsuarioExecutor : logged.id
  //     })
  //   }

  //   fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade/`, params)
  //     .then(response => {
  //       const { status } = response
  //       response.json().then(data => {
  //         setOpenLoadingDialog(false)
  //         if (status === 401) {
  //           setMessage(data.message)
  //           setOpenMessageDialog(true)
  //         } else if (status === 200) {
  //           setAtividade(data.data)
  //           setMessage(data.message)
  //           setOpenMessageDialog(true)
  //           window.location.href = `${process.env.REACT_APP_DOMAIN}/home/`


  //           // setArea(data.data)
  //         }
  //       }).catch(err => setOpenLoadingDialog(true))
  //     })
  // }

  const novaInteracao = () => {
    setOpenLoadingDialog(true)


    const token = getCookie('_token_task_manager')
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        fkAtividade: id,
        conteudo,
        email: emailUsuarioSolicitante,
        emailExecutor: emailExecutor,
        caminho,
        listaDeArquivosEnviados



      })
    }

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/mensagem/`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          setOpenLoadingDialog(false)
          if (status === 401) {
            setMessage(data.message)
            setOpenMessageDialog(true)
          } else if (status === 200) {
            setOpenLoadingDialog(false)
            // alert(JSON.stringify(data.data))
            // alert(JSON.stringify(arquivoDoChamado))
            setAtividade(data.data)
            setMessage(data.message)
            setOpenMessageDialog(true)

            window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${idChamado}/edit`


            // setArea(data.data)

          }
        }).catch(err => setOpenLoadingDialog(true))
      })

  }


  function isValidCPF(cpf) {
    cpf = cpf.replace(/[^\d]/g, ''); // Remove caracteres não numéricos

    // Verifica se o CPF tem 11 dígitos
    if (cpf.length !== 11) {
      return false;
    }

    // Verifica se todos os dígitos são iguais (ex: 000.000.000-00)
    if (/^(\d)\1+$/.test(cpf)) {
      return false;
    }

    // Validação dos dígitos verificadores
    let sum = 0;
    let remainder;

    for (let i = 1; i <= 9; i++) {
      sum += parseInt(cpf[i - 1]) * (11 - i);
    }

    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === parseInt(cpf[9])) {
      sum = 0;
      for (let i = 1; i <= 10; i++) {
        sum += parseInt(cpf[i - 1]) * (12 - i);
      }
      remainder = (sum * 10) % 11;
      return remainder === 10 || remainder === parseInt(cpf[10]);
    }

    return false;
  }






  const checarTermo = () => {

    const camposObrigatorios = ['cpf'];
    if (!isValidCPF(cpfTermo)) {
      mensagens1('CPF  Inválido')
      setOpenLoadingDialog(false)
      return;
    } else {
      checar()
    }

  };

  function mensagens1(msg) {
    setMensagemAlert(msg)
    setOpenMensagens(true)
  }


  function checar() {
    const token = getCookie('_token_task_manager');
    const params = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/atividade/termo/${cpfTermo}`, params)
      .then(response => {
        const { status } = response;
        console.log('Status da resposta:', status);

        response.json().then(data => {
          console.log('Dados da resposta:', data);

          setOpenLoadingDialog(false);
          if (status === 401) {
            console.error('Erro 401: Não Autorizado');
            // Adicione o código para lidar com o erro 401 aqui
          } else if (status === 200) {
            console.log('Sucesso: Termo de Compromisso assinado');
            mensagens1(data.message)
            setTermo(false)
            setOpenMensagens(true)
            // Adicione o código para lidar com o sucesso aqui
          }
        }).catch(err => {
          console.error('Erro ao processar resposta JSON:', err);
          setOpenLoadingDialog(true);
        });
      }).catch(err => {
        console.error('Erro na solicitação:', err);
        console.log(err)
        setOpenLoadingDialog(true);
      });
  }


  function log() {
    // alert('55')
    const token = getCookie('_token_task_manager');
    const params = {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/usuarioAtividade/${idChamado ? idChamado : ''}`, params)
      .then(response => {
        const { status } = response;
        console.log('Status da resposta:', status);

        response.json().then(data => {
          console.log('Dados da resposta:', data);

          setOpenLoadingDialog(false);
          if (status === 401) {
            console.error('Erro 401: Não Autorizado');
            // Adicione o código para lidar com o erro 401 aqui
          } else if (status === 200) {
            setLogChamado(data.data)

            // alert(data.message)

            // Adicione o código para lidar com o sucesso aqui
          }
        }).catch(err => {
          console.error('Erro ao processar resposta JSON:', err);
          setOpenLoadingDialog(true);
        });
      }).catch(err => {
        console.error('Erro na solicitação:', err);
        console.log(err)
        setOpenLoadingDialog(true);
      });
  }





  const generateColor = (nome) => {
    const colors = ['#f6dead', '#f5c7b8', '#f6e7da', '#f7c4a2', '#f7b8d5'];
    let hash = 0;
    for (let i = 0; i < nome.length; i++) {
      hash = nome.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  const criarExecucao = () => {

    // alert(emailExecutor)
    const token = getCookie('_token_task_manager')
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        fkClassificacao: newClassificacao,
        fkAtividade: idChamado,
        fkUsuario: fkUsuarioExecutor,
        ativo: true,
        email: emailExecutor,
        conteudoFuncionario2,
        fkUsuarioExecutor2



      })
    }

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/usuarioAtividade/`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          setOpenLoadingDialog(false)
          if (status === 401) {
            // alert('o1')
            setMessage(data.message)
            setOpenMessageDialog(true)
          } else if (status === 200) {


            setAtividade(data.data)
            setMessage(data.message)
            setOpenMessageDialog(true)
            window.location.href = `${process.env.REACT_APP_DOMAIN}/home`

            // setArea(data.data)
          }
        }).catch(err => setOpenLoadingDialog(true))
      })
  }

  const sendFile = (method, url, params) => {
    const token = getCookie('_token_task_manager')

    return new Promise(function (resolve, reject) {
      let req = new XMLHttpRequest();
      req.open(method, url);
      req.setRequestHeader("Authorization", `Bearer ${token}`);

      req.addEventListener(
        "load",
        () => {
          if (req.status === 200) {
            resolve(JSON.parse(req.responseText));
          } else {
            reject(JSON.parse(req.responseText));
          }
        },
        false
      );
      req.send(params);
    });
  };

  function baixar(item) {
    window.location.href = `${process.env.REACT_APP_DOMAIN_API}/api/arquivo/${item}`

    // window.location.href = `${process.env.REACT_APP_DOMAIN}/atividade/${idChamado}/edit`

  }

  const getColorFromName = (name) => {
    const colors = ['#dddbd8', , '#e6f1d7', '#def8bb', '#d8fca7', '#ecf2b5'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };






  const enviarArquivo = (e) => {


    setArquivo(e)
    // alert(JSON.stringify(e))
    const form = new FormData()


    form.append('arquivo', e)

    sendFile("POST", `${process.env.REACT_APP_DOMAIN_API}/api/arquivo`, form)
      .then(response => {
        const { data } = response
        setOpenLoadingDialog(true)

        setListaDeArquivosEnviados([...listaDeArquivosEnviados, data])
        setCaminho(data.caminho)
        setOpenLoadingDialog(false)
        // alert(JSON.stringify(listaDeArquivosEnviados))

        // alert(JSON.stringify(response))
      })
      .catch(err => {
        alert(JSON.stringify(err))
      })
  }




  const sendVideoFile = (method, url, formData) => {
    const token = getCookie('_token_task_manager');

    return new Promise(function (resolve, reject) {
      let req = new XMLHttpRequest();
      req.open(method, url);
      req.setRequestHeader("Authorization", `Bearer ${token}`);

      req.addEventListener(
        "load",
        () => {
          if (req.status === 200) {
            resolve(JSON.parse(req.responseText));
          } else {
            reject(JSON.parse(req.responseText));
          }
        },
        false
      );

      req.send(formData);
    });
  };






  return (

    <PageContainer>


      {id ? <div style={{ flex: 1, marginBottom: 16, marginLeft: 25 }}>
        <TextField size="small" fullWidth label="Protocolo" disabled variant="outlined" value={protocolo} />
      </div> : ''}

      {checkDemandante ?
        <div>
          'Chamado arquivado'

        </div>
        : ''}







      {id ? <div >
        <TaskItemDoChamado

          log={logChamado}
          outro={outrosExecutores[0]?.Usuario?.nome}

          protocolo={protocolo}
          unidade={valueUnidade}
          categoria={categoriaChamado}
          area={valueArea}
          classificacao={classificacao}
          solicitante={usuarioSolicitante}
          status={status}
          titulo={title}
          emailUsuarioSolicitante={emailUsuarioSolicitante}
          telefoneSolicitante={telefoneSolicitante}
          setorSol={valueUnidade}
          nomeExecutor={nomeExecutor}
          emailExecutor={emailExecutor}
          telefoneExecutor={telefoneExecutor}
          setorSolicitante={setorSolicitante}


        />
      </div> : ''}
      <center>
        {(logged && logged.fkArea === fkAreaDemandada && logged.Perfil.nome === PerfilUtils.Coordenador) ||
          (logged && logged.Perfil.nome === PerfilUtils.Gerente && logged.Area.fkUnidade === fkUnidadeExecutor)

          ?
          <div style={{ flex: 1, marginBottom: 16, marginLeft: 5 }}>
            <Button variant="contained" size='small' color="error" onClick={() => setOpen(true)}>Selecionar Funcionario<PersonIcon></PersonIcon></Button>
          </div> : ''

        }

        {!checkDemandante && (logged && props.logged.id === fkExecutor) || logged && logged.Perfil.nome === PerfilUtils.Coordenador && props.logged.fkArea === fkAreaDemandada ?
          <div style={{ flex: 1, marginBottom: 16, marginLeft: 5 }}>
            <Button variant="contained" size='small' color="error" onClick={() => setOpenStatus(true)}>Alterar Status da Atividade</Button>
          </div> : ''

        }


      </center>

      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 16, marginRight: 3 }}>







        <div style={{ flex: 1 }}></div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>

        {!id ? <>
          {logged ? <TaskFilter nome={props.logged.nome + ', solicite uma atividade'} setSetorSolicitante={props.logged.Area?.Unidade.nome} />
            :
            ''
          }
          <FormGroup>

            <div style={{ flex: 1, marginBottom: 16, wordBreak: 'break-all' }}
            >
              Solicitar Atividade para :<br></br>





              <FormControl fullWidth size="small">

                <InputLabel id="demo-select-small">Unidade</InputLabel>
                <Select
                  fullWidth
                  labelId="demo-select-small"
                  id="demo-select-small"
                  label="Unidade"
                  value={fkUnidade}>
                  <MenuItem value="" onClick={() => setFkUnidadeDrop("")}>
                    {/* <em>Nenhum</em> */}
                  </MenuItem>
                  {unidade.map((item, index) => {
                    if (item.receber === true) {
                      return <MenuItem key={index} value={item.id} onClick={(e) => [setFkUnidade(item.id), setDep(item.nome)]}>{item.nome}</MenuItem>
                    }
                  })}
                </Select>
              </FormControl>
            </div>

            <div style={{ flex: 1, marginBottom: 16, wordBreak: "break-all" }}>
              <FormControl fullWidth size="small">
                <InputLabel id="demo-select-small">Área</InputLabel>
                <Select
                  fullWidth
                  labelId="demo-select-small"
                  id="demo-select-small"
                  label="Area"
                  value={fkArea}>
                  <MenuItem value="" onClick={() => setFkUnidade("")}>
                    <em>Nenhum</em>
                  </MenuItem>
                  {area.map((item, index) => <MenuItem key={index} value={item.id} onClick={() => [setFkArea(item.id), setGti(item.nome)]}>{item.nome}</MenuItem>)}
                </Select>
              </FormControl>
            </div>
            {dep === 'DEP'
              ?
              <div style={{ flex: 1, marginBottom: 16 }}>
                <FormControl size="small" fullWidth>
                  <InputLabel id="demo-select-small">Categoria</InputLabel>
                  <Select
                    fullWidth

                    labelId="demo-select-small"
                    id="demo-select-small"
                    label="categoria"
                    value={categoria}>
                    <MenuItem value="" onClick={() => setArea("")}>
                      <em>Nenhum</em>
                    </MenuItem>
                    {subArea.map((item, index) => <MenuItem key={index} value={item.nome} onClick={() => setCategoria(item.nome)}>{item.nome}</MenuItem>)}


                  </Select>
                </FormControl>
              </div>
              : ''}


            {gti === 'Sistemas - Desenvolvimento'
              ?
              <div style={{ flex: 1, marginBottom: 16 }}>
                <tr>
                  <td style={{ color: 'red' }}>
                    Seu chamado e para solicitar liberação de sistema para funcionário?

                  </td>
                  <td>
                    <FormControl>
                      <RadioGroup

                        onChange={(event) => setTermo(event.target.value === 'sim')}
                      >
                        <FormControlLabel value="sim" control={<Radio />} label="sim" />
                        {/* <FormControlLabel value="não" control={<Radio />} label="não" /> */}
                      </RadioGroup>
                    </FormControl>

                  </td>
                </tr>


              </div>
              : ''}

            <div style={{ flex: 1, marginBottom: 16 }}>
              <TextField size="small" fullWidth label="Título" variant="outlined" value={titulo} onChange={e => setTitulo(e.target.value)} />
            </div>
            {/* <div style={{ flex: 1, marginBottom: 16 }}>
              <TextField size="small" fullWidth label="Descrição" multiline rows={2} variant="outlined" value={conteudo} onChange={e => setConteudo(e.target.value)} />
            </div> */}

            <div style={{ flex: 1, marginBottom: 16 }}>
              {/* Substituindo o TextField por um ReactQuill */}

              <ReactQuill
                value={conteudo}
                onChange={setConteudo}
                theme="snow"
                placeholder="Descrição do Chamado..."
                 style={{ height: '150px' }} // ajuste conforme necessário
              />
            </div>


            {titulo && conteudo
              ?
              <div style={{ flex: 1, marginBottom: 16 }}>
                <tr>
                  <td style={{ color: 'red' }}>
                    Funcionário para acompanhamento?

                  </td>
                  <td>
                    <FormControl>
                      <RadioGroup

                        onChange={(event) => setTermo1(event.target.value === 'sim')}
                      >
                        <FormControlLabel value="sim" control={<Radio />} label="sim" />
                        {/* <FormControlLabel value="não" control={<Radio />} label="não" /> */}
                      </RadioGroup>
                    </FormControl>

                  </td>
                </tr>


              </div>
              : ''}
            {/* <div style={{ flex: 1, marginBottom: 16 }}>
              <TextField size="small" fullWidth label="Descrição" multiline rows={2} variant="outlined" value={conteudo} onChange={e => setConteudo(e.target.value)} />
              <Button color="success" variant="contained" onClick={() => setOpenImg(true)}>{'Anexar'}<AttachFileSharpIcon></AttachFileSharpIcon></Button>
            </div> */}

            {/* <div style={{ flex: 1, marginBottom: 16 }}>
              <File size="small" fullWidth label="Descrição" multiline rows={2} variant="outlined" value={conteudo} onChange={e => setConteudo(e.target.value)} />
            </div> */}
            {/* <UploadButton></UploadButton> */}
            {/* <input type={"file"} accept="image/*, video/*" enctype="multipart/form-data" onChange={(e) => enviarArquivo(e.target.files[0])} /> */}




            {/* <input type="file" accept="video/mp4" onChange={(e) => enviarVideoMp4(e)} /> */}



            {listaDeArquivosEnviados.map((item, key) => <b style={{ color: 'blue', fontSize: 11 }}>{item.nomeApresentacao + ' Adicionado'}</b>)}
            <hr></hr>
            {/* Enviar video<OndemandVideoIcon/> */}

            {/* 
            classificarChamado.map((classificacao, key) => <option name={classificacao.nome} value={classificacao.id} >
                  {classificacao.nome}</option>) */}

            <div style={{ borderRadius: '8px', overflow: 'hidden', marginTop:'20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
              <a>
                <img
                  src={anexo}
                  height={50}
                  onClick={() => setOpenMsg2(true)}
                  style={{ cursor: 'pointer', border: '2px solid #ddd', borderRadius: '8px', transition: 'transform 0.3s ease' }}
                  onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                  onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                />
              </a>
            </div>

            <div style={{ flex: 1, display: 'flex', flexDirection: 'row', alignSelf: "self-start" }}>
              {/* <Button variant="outlined" onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN}/area/`}>Voltar</Button> */}
              <div style={{ flex: 1 }}></div>
              <Button variant="contained"
                disabled={botaoDesabilitado}
                onClick={onSave}>{'abrir chamado'}</Button>
            </div>
            {/* <TextField
              type="hidden"
              value={setorSolicitante}
              onChange={(event) => setSetorSolicitante(logged.Area.Unidade.nome)}
            /> */}
          </FormGroup>



        </> : ''}

        {uploadResult && (
          <div style={{ marginTop: '20px', padding: '10px', border: '1px solid green' }}>
            {uploadResult.message === "Cadastro realizado com sucesso." ? (
              <div>
                {/* <p><strong>Sucesso:</strong> {uploadResult.message}</p> */}
                <p><strong>Nome do Arquivo:</strong> {uploadResult.data.nome}</p>
                <p><strong>Tamanho:</strong> {uploadResult.data.tamanho}</p>
                {/* <p><strong>Hash:</strong> {uploadResult.data.hash}</p> */}

              </div>
            ) : (
              <p><strong>Erro:</strong> {uploadResult.message}</p>
            )}
          </div>
        )}


        {/* {envioFuncionario ? <div style={{flex: 1, marginBottom: 16}}>
          <TextField size="small" fullWidth label="Solicitante" disabled variant="outlined" value='ssssssssddfdfssfgd' />
        </div> : 'dddddd'} */}
        {/* {mensagens =! null ? <div>{
          mensagens[0].id}  </div>: '' } */}

        {/* {area.map((item, index) => <b key={index} value={item.id} >{item.nome}</b>)} */}


        {id ? <>

          {/* {arquivoDoChamado.length
            ?
            <div style={{ borderTop: '1px solid #e0e0e0', 
            padding: 2, background: '#FFEEE0', borderRadius: 10, marginBottom: 1,
             border: '2px solid #e0e0e0' }}>
              <div style={{fontSize:15}}>Anexos</div>
              {

                <table>
                  <tr>
                    <td>Arquivo</td>
                    <td></td>
                  </tr>
                  {arquivoDoChamado.map((item, index) => <tr>
                    <td >{item.nomeApresentacao}</td>
                    <td>{<button onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN_API}/api/arquivo/${item.id}`}>Abrir</button>}</td>
                  </tr>)}
                </table>
              
              }
            </div>

            :
            ''
          } */}






          {checkDemandante ?
            '' :
            <div>

              {logged && (props.logged.id !== fkUsuarioExecutor && props.logged.id !== fkDemandante) && (
                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '16px' }}>
                  {/* Primeira Imagem */}
                  <div style={{ marginRight: '10px', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>





                    <img
                      src={mensagemft}
                      height={70}
                      onClick={() => setOpenMsg(true)}
                      style={{ cursor: 'pointer', border: '2px solid #ddd', borderRadius: '8px', transition: 'transform 0.3s ease' }}
                      onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                      onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                    />
                  </div>

                  {/* Segunda Imagem */}
                  <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                    <a>
                      <img
                        src={anexo}
                        height={70}
                        onClick={() => setOpenMsg1(true)}
                        style={{ cursor: 'pointer', border: '2px solid #ddd', borderRadius: '8px', transition: 'transform 0.3s ease' }}
                        onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                        onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                      />
                    </a>
                  </div>

                  <div style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                    <a>
                      <img
                        src={send}
                        height={70}
                        onClick={() => setOpenMsg3(true)}
                        style={{ cursor: 'pointer', border: '2px solid #ddd', borderRadius: '8px', transition: 'transform 0.3s ease' }}
                        onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                        onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                      />
                    </a>
                  </div>

                </div>
              )}

            </div>}

          {arquivoDoChamado.length > 0 && (
            <div
              style={{
                borderTop: '1px solid #e0e0e0',
                padding: 10,

                borderRadius: 10,
                marginBottom: 10,
                border: '2px solid #e0e0e0',
              }}
            >

              <div

              >
                {arquivoDoChamado
                  .filter(item => !item.hash && item.caminho.includes('uploads')) // Filtra para mostrar apenas itens sem 'hash' e com 'uploads' no caminho
                  .map((item, index) => (
                    <Button
                      key={index}
                      size="small"
                      style={{
                        display: 'inline-flex',
                        margin: '5px',
                        fontSize: '12px',

                        border: '1px solid #e0e0e0',
                        borderRadius: '5px',
                        textTransform: 'none',
                      }}
                      onClick={() => baixar(item.id)}
                    >
                      <AttachFileIcon style={{ marginRight: 2 }} />
                      {item.nomeApresentacao}
                    </Button>
                  ))}

              </div>
              <FileViewer arquivoDoChamado={arquivoDoChamado ? arquivoDoChamado : ''} />
            </div>
          )}



          {/* {arquivoDoChamado.length ?
            
            : ''} */}










          <div style={{ marginLeft: 20, marginBottom: 0 }}>
            <b>Mensagens </b>
          </div>
          {mensagens.map((item, index) => {
            const bubbleColor = item.Usuario ? getColorFromName(item.Usuario.nome) : '#f6dead';
            const isCurrentUser = item.Usuario?.nome === 'Você'; // Verifica se é o usuário atual
            const userFirstName = item.Usuario?.nome ? item.Usuario.nome.split(' ')[0] : ''; // Pega apenas o primeiro nome

            return (
              <div>

                <div key={index} style={{
                  display: 'flex',
                  justifyContent: isCurrentUser ? 'flex-end' : 'flex-start',
                  alignItems: 'flex-end', // Alinha os elementos ao final
                  marginBottom: 10,

                  borderTop: '1px solid #e0e0e0',
                  padding: 10,
                  background: '#F5FFFA',
                  borderRadius: 10,
                  marginBottom: 10,
                  border: '2px solid #e0e0e0',

                }}>
                  {/* Ícone do usuário com o primeiro nome */}
                  {!isCurrentUser && (
                    <div style={{
                      width: 35,
                      height: 35,

                      borderRadius: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginRight: 33,
                      fontSize: 12,

                      fontWeight: 'bold',
                    }}>
                      {userFirstName}
                    </div>
                  )}

                  {/* Balão de fala */}
                  <div style={{
                    maxWidth: '60%',
                    padding: '10px',
                    backgroundColor: bubbleColor,
                    borderRadius: '15px',
                    position: 'relative',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    wordBreak: 'break-word',
                  }}>


                    {/* Conteúdo da mensagem */}
                    <p
                      style={{
                        fontSize: 14,
                        margin: '5px 0',
                        padding: 0,
                        color: '#333',
                      }}
                      dangerouslySetInnerHTML={{ __html: item.conteudo }}
                    />

                    {/* Data e hora da mensagem */}

                    <span style={{
                      fontSize: 10,
                      color: '#999',
                      display: 'block',
                      textAlign: 'right',
                    }}>
                      {new Date(new Date(item.createdAt).getTime() + 3 * 60 * 60 * 1000).toLocaleString()}
                    </span>

                    {/* Triângulo do balão de fala */}

                  </div>


                  {/* Ícone do usuário para mensagens do próprio usuário */}
                  {isCurrentUser && (
                    <div style={{
                      width: 35,
                      height: 35,
                      backgroundColor: '#ccc',
                      borderRadius: '50%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginLeft: 10,
                      fontSize: 114,
                      color: '#f49621',
                      fontWeight: 'bold',
                    }}>
                      {userFirstName}
                    </div>
                  )}
                  <hr></hr>
                </div>

              </div>


            );
          })}




        </> : ''}

      </div>

      <Dialog open={openLoadingDialog}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 120, height: 120 }}>
          <CircularProgress />
        </div>
      </Dialog>

      <Dialog
        open={openMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          Atenção
        </DialogTitle>
        <DialogContent style={{ width: 400 }}>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => [setOpenMessageDialog(false), setTermo(false)]}>
            fechar
          </Button>
        </DialogActions>
      </Dialog>

      {openFile.length ?
        <Dialog
          open={openDialogFile} onClose={() => setOpenDialogFile(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            Anexo
          </DialogTitle>
          <DialogContent >
            <DialogContentText id="alert-dialog-description">
              <embed src={window.location.href = `${process.env.REACT_APP_DOMAIN_API}/api/arquivo/${openFile}`} ></embed>

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button >
              OK
            </Button>
          </DialogActions>


        </Dialog>
        :
        ''
      }



      <hr></hr>

      <Dialog open={open} >
        <DialogTitle style={{ color: '#1E90FF' }} >Encaminhar Atividade</DialogTitle>
        <DialogContent>


          <InputLabel id="demo-select-small"><b>Titulo Atividade:</b></InputLabel>
          {title}
          <br></br>
          <InputLabel id="demo-select-small"><b>Unidade</b></InputLabel>
          {valueUnidade}
          <InputLabel id="demo-select-small"><b>Solicitante</b></InputLabel>
          {usuarioSolicitante}

          <hr></hr>

          <p></p>

          <FormControl fullWidth labelId="demo-simple-select-label" id="demo-simple-select">


            <select style={{ fontSize: 14 }} onChange={e => setNewClassificacao(e.target.value)}>
              <option >CLASSIFIQUE A ATIVIDADE</option>)

              {
                classificarChamado.map((classificacao, key) => <option name={classificacao.nome} value={classificacao.id} >
                  {classificacao.nome}</option>)
              }
            </select>

            <hr></hr>


            {valueUnidade === 'GTI' ?
              <div>


                <select style={{ fontSize: 14 }} onChange={e => setFKUsuarioExecutor(e.target.value)}>

                  <option style={{ fontWeight: 'bold', fontSize: '16px' }}>Sistemas - Desenvolvimento</option>
                  {
                    usuarioExecutor
                      .filter(user => user.Area.nome === 'Sistemas - Desenvolvimento')
                      .map((user, key) => (
                        <option name={user.nome} value={user.id}>
                          {user.nome}-{meuSetorCount.map(i => i.fkUsuarioExecutor).filter(i => user.id === i).length}  Chamados
                        </option>
                      ))
                  }
                  <option style={{ fontWeight: 'bold', fontSize: '16px' }}>Suporte e Infraestrutura</option>
                  {
                    usuarioExecutor
                      .filter(user => user.Area.nome === 'Suporte e Infraestrutura')
                      .map((user, key) => (
                        <option name={user.nome} value={user.id}>
                          {user.nome}-{meuSetorCount.map(i => i.fkUsuarioExecutor).filter(i => user.id === i).length} Chamados
                        </option>
                      ))
                  }


                </select>


              </div>

              :

              ""

            }


            {valueUnidade === 'Faculdade' ?
              <div>


                <select style={{ fontSize: 14 }} onChange={e => setFKUsuarioExecutor(e.target.value)}>
                  <option>SELECIONE O EXECUTOR</option>
                  {
                    valueUnidade === 'Faculdade'
                      ? usuarioExecutor
                        .filter(user =>
                          ['marcossalgueiro@pe.senac.br', 'danilogusmao@pe.senac.br', 'wellingtonfranca@pe.senac.br']
                            .includes(user.email)
                        )
                        .map((user, key) => (
                          <option key={key} name={user.nome} value={user.id}>
                            {user.nome}
                          </option>
                        ))
                      : usuarioExecutor.map((user, key) => (
                        <option key={key} name={user.nome} value={user.id}>
                          {user.nome}
                        </option>
                      ))
                  }
                </select>


              </div>

              :

              ""

            }


            {valueUnidade !== 'GTI' && valueUnidade !== 'Faculdade' ?
              <div>


                <select style={{ fontSize: 14 }} onChange={e => setFKUsuarioExecutor(e.target.value)}>

                  <option >SELECIONE  O EXECUTOR</option>
                  {
                    usuarioExecutor.map((user, key) => <option name={user.nome} value={user.id} >
                      {user.nome}</option>)
                  }

                </select>




              </div>


              :

              ""

            }








          </FormControl>


          {fkUsuarioExecutor != '' &&
            valueUnidade === 'GTI' ?
            <div style={{ color: 'red' }}>
              Este chamado terá mais um executor?
              <RadioGroup

                onChange={(event) => setTermo2(event.target.value === 'sim')}
              >
                <FormControlLabel value="sim" control={<Radio />} label="sim" />
                {/* <FormControlLabel value="não" control={<Radio />} label="não" /> */}
              </RadioGroup>

            </div>
            : ''}

        </DialogContent>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
          {fkUsuarioExecutor != '' && newClassificacao != '' && (
            <div>
              <DialogActions>
                <Button onClick={() => { criarExecucao() }}>Enviar</Button>
              </DialogActions>
            </div>
          )}
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
        </div>


      </Dialog>

      <Dialog open={openStatus}  >

        <DialogContent>
          <DialogContentText>

          </DialogContentText>

          <p></p>

          <FormControl labelId="demo-simple-select-label" id="demo-simple-select" style={{ width: 250 }}>
            <InputLabel id="demo-simple-select-label">{status}</InputLabel>


            <Select style={{ fontSize: 20 }} onChange={e => setNewStatus(e.target.value)}>
              {/* <option>{status}</option> */}


              {
                alterarStatus.map((status, key) => <MenuItem name={status.nome} value={status.id} >
                  {status.nome}</MenuItem>)
              }
            </Select>

          </FormControl>

        </DialogContent>
        <DialogActions>
          {newStatus != '' ?
            <div>
              <DialogActions>

                <Button onClick={() => { onSaveStatus() }} >Alterar</Button>
              </DialogActions>

            </div>
            : ''}
          <Button onClick={() => setOpenStatus(false)}>Cancelar</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openMsg}>
        <DialogContent>
          {openStatus === false ? (
            <h2 style={{ fontFamily: 'Arial, sans-serif', fontWeight: '600', fontSize: '24px', color: '#333' }}>
              Deixe uma mensagem
            </h2>
          ) : (
            <h4 style={{ fontFamily: 'Arial, sans-serif', fontWeight: '500', fontSize: '20px', color: '#555' }}>
              Informe o motivo da alteração do Status
            </h4>
          )}

          <div style={{ flex: 1, marginBottom: 16 }}>
            {/* Substituindo o TextField por um ReactQuill */}

            <ReactQuill
              value={conteudo}
              onChange={setConteudo}
              theme="snow"
              placeholder="faça um comentário neste chamado ..."
               style={{ height: '200px' }} // ajuste conforme necessário
             
            />
          </div>


          {listaDeArquivosEnviados.map((item, key) => (
            <b key={key} style={{ color: 'blue', fontSize: '12px', display: 'block', marginBottom: '4px' }}>
              {item.nomeApresentacao + ' Adicionado'}
            </b>
          ))}

          <hr style={{ margin: '20px 0', borderColor: '#ddd' }} />

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Button
              variant="contained"
              onClick={novaInteracao}
              style={{ padding: '10px 20px', borderRadius: '8px', fontWeight: 'bold' }}
            >
              Enviar
            </Button>

            <Button
              onClick={() => setOpenMsg(false)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#555',
                cursor: 'pointer',
                fontWeight: 'bold',
                textDecoration: 'underline'
              }}
            >
              Voltar para o chamado
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={openMsg1}>
        <DialogContent>
          <hr style={{ margin: '20px 0', borderColor: '#ddd' }} />

          <Upload fkAtividade={id ? id : ''} />

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => setOpenMsg1(false)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#555',
                cursor: 'pointer',
                fontWeight: 'bold',
                textDecoration: 'underline'
              }}
            >
              Voltar para o chamado
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={openMsg3}>
        <DialogContent>

          {emailAC ?
            <div>
              <div style={{ flex: 1, marginBottom: 16, marginLeft: 25 }}>
                <b>
                  Funcionario marcado:
                </b>
                <br></br>{emailAC}
              </div>
            </div>
            :
            <div>
              <h2>Marque um funcionário </h2>

              Selecione um email para acompanhar este chamado

              <Autocomplete
                options={emailsFuncionarios || []}
                getOptionLabel={(option) => option.email || ''} // Mostra o campo email
                inputValue={pesquisa}
                onInputChange={(event, newInputValue) => {
                  setPesquisa(newInputValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    label="Digite o email do funcionário"
                    name="pesquisa"
                    style={{ backgroundColor: "#FFFACD" }}
                  />
                )}
              />
              <hr></hr>

              {emailsFuncionarios.length === 1 && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleEncaminharTarget(emailsFuncionarios[0].email)} // Passa o email único
                  style={{ marginTop: '10px' }}
                >
                  Encaminhar para este funcionário
                </Button>
              )}

              {/* Exibe o email armazenado em ordem */}
              {ordem && <p>será encaminhado emails para: {ordem}</p>}


            </div>
          }

          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => setOpenMsg3(false)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#555',
                cursor: 'pointer',
                fontWeight: 'bold',
                textDecoration: 'underline'
              }}
            >
              Voltar para o chamado
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={openMsg2}>
        <DialogContent>
          <hr style={{ margin: '20px 0', borderColor: '#ddd' }} />
          <div style={{ color: 'red' }}>
          </div>
          <p></p>
          <div>
            <h2>Selecione o arquivo e clique em enviar</h2>
            <input
              type="file"
              ref={fileInputRef}
              style={{
                padding: '10px',
                borderRadius: '5px',
                border: '1px solid #ccc',
                marginBottom: '20px',
                width: '100%',
                fontSize: '16px'
              }}
            />
            <button
              onClick={handleUpload}
              style={{
                backgroundColor: '#108cdd',
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px',
                transition: 'red'
              }}
              onMouseEnter={e => e.target.style.backgroundColor = 'red'}
              onMouseLeave={e => e.target.style.backgroundColor = '#108cdd'}
            >
              Enviar
            </button>

            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              onClick={() => setOpenMsg2(false)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#555',
                cursor: 'pointer',
                fontWeight: 'bold',
                textDecoration: 'underline'
              }}
            >
              Voltar para o chamado
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={termo}  >

        <DialogContent>

          {openStatus === false ?
            <h2>Informe o cpf do funcionário</h2>
            : <h4></h4>}

          <div style={{ flex: 1, marginBottom: 2 }}>
            <TextField fullWidth sx={{ m: 1 }} size='200px' label='Digite o CPF' variant="outlined" value={cpfTermo} onChange={e => setCpfTermo(e.target.value)} />
          </div>
          <hr></hr>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
            {/* <Button variant="outlined" onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN}/area/`}>Voltar</Button> */}
            <div style={{ flex: 1 }}></div>
            <Button variant="contained" onClick={checarTermo}>{'Checar termo de compromisso'}</Button>
            <Button onClick={() => setTermo(false)}>sair</Button>


          </div>
        </DialogContent>

      </Dialog>

      <Dialog open={termo1}  >

        <DialogContent>


          <h2>Insira o email do funcionário</h2>

          O email a seguir receberá informações do andamento do chamado

          <Autocomplete
            options={emailsFuncionarios || []}
            getOptionLabel={(option) => option.email || ''} // Mostra o campo email
            inputValue={pesquisa}
            onInputChange={(event, newInputValue) => {
              setPesquisa(newInputValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                fullWidth
                label="Digite o email do funcionário"
                name="pesquisa"
                style={{ backgroundColor: "#FFFACD" }}
              />
            )}
          />



          <hr></hr>

          {emailsFuncionarios.length === 1 && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleEncaminhar(emailsFuncionarios[0].email)} // Passa o email único
              style={{ marginTop: '10px' }}
            >
              Encaminhar para este funcionário
            </Button>
          )}

          {/* Exibe o email armazenado em ordem */}
          {ordem && <p>será encaminhado emails para: {ordem}</p>}


          <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
            {/* <Button variant="outlined" onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN}/area/`}>Voltar</Button> */}
            <div style={{ flex: 1 }}></div>
            {/* <Button variant="contained" onClick={checarTermo}>{'Checar termo de compromisso'}</Button> */}


            <Button onClick={() => setTermo1(false)}>sair</Button>


          </div>
        </DialogContent>

      </Dialog>

      <Dialog open={termo2}  >

        <DialogContent>
          <h2>Selecionario outro funcionário que atenderá este chamado</h2>

          <div>


            <select style={{ fontSize: 14 }} onChange={e => setFKUsuarioExecutor2(e.target.value)}>

              <option style={{ fontWeight: 'bold', fontSize: '16px' }}>Sistemas - Desenvolvimento</option>
              {
                usuarioExecutor
                  .filter(user => user.Area.nome === 'Sistemas - Desenvolvimento')
                  .map((user, key) => (
                    <option name={user.nome} value={user.id}>
                      {user.nome}-{meuSetorCount.map(i => i.fkUsuarioExecutor).filter(i => user.id === i).length}  Chamados
                    </option>
                  ))
              }
              <option style={{ fontWeight: 'bold', fontSize: '16px' }}>Suporte e Infraestrutura</option>
              {
                usuarioExecutor
                  .filter(user => user.Area.nome === 'Suporte e Infraestrutura')
                  .map((user, key) => (
                    <option name={user.nome} value={user.id}>
                      {user.nome}-{meuSetorCount.map(i => i.fkUsuarioExecutor).filter(i => user.id === i).length} Chamados
                    </option>
                  ))
              }


            </select>
            {fkUsuarioExecutor2 ?
              <TextField
                fullWidth
                sx={{ m: 1 }}
                size='200px'
                label='Digite alguma instrução para este funcionario'
                multiline
                rows={2}
                variant="outlined"
                value={conteudoFuncionario2}
                onChange={e => setConteudoFuncionario2(e.target.value)}
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  padding: '10px',
                  fontFamily: 'Arial, sans-serif',
                  backgroundColor: '#f9f9f9'
                }}
              />

              : ''}
            <hr></hr>



          </div>




          <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
            {/* <Button variant="outlined" onClick={() => window.location.href = `${process.env.REACT_APP_DOMAIN}/area/`}>Voltar</Button> */}

            <Button onClick={() => setTermo2(false)}>voltar para concluir o chamado</Button>


          </div>
        </DialogContent>

      </Dialog>

      <Dialog open={openMensagens}  >

        <DialogContent>


          {mensagemAlert}


          <div style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>

            <div style={{ flex: 1 }}></div>

            <Button onClick={() => window.location.reload()}>Sair</Button>



          </div>
        </DialogContent>

      </Dialog>


      <Dialog open={openValidation}>
        <DialogContent>
          <div style={{ textAlign: "center", padding: "20px" }}>
            <p style={{ fontSize: "18px", marginBottom: "16px" }}>
              Sua solicitação foi concluida, precisamos do seu feedback.
            </p>
            <Button
              onClick={() =>
                (window.location.href = `${process.env.REACT_APP_DOMAIN}/validarChamado/${id}`)
              }
              style={{
                padding: "10px 20px",
                fontSize: "16px",
                color: "#fff",
                backgroundColor: "#007bff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginBottom: "16px",
              }}
            >
              Clique aqui
            </Button>
            <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>
              <div style={{ flex: 1 }}></div>
              <Button
                onClick={() => window.location.reload()}
                style={{
                  padding: "10px 20px",
                  fontSize: "16px",
                  color: "#007bff",
                  backgroundColor: "transparent",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Sair
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>








    </PageContainer>
  );
};

export default AtividadeForm;